import * as React from 'react';
import { cn } from '../../lib/utils';
import { Card, CardContent } from './card';
import { Button } from './button';

/**
 * EmptyState component for list views with zero entities.
 * Renders a card with title, description, and optional CTA button.
 * Ensures no blank page is shown when data is absent.
 */
interface EmptyStateProps {
  readonly title: string;
  readonly description: string;
  readonly actionLabel?: string;
  readonly onAction?: () => void;
  readonly className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  actionLabel,
  onAction,
  className,
}) => (
  <Card className={cn('mx-auto max-w-md text-center', className)}>
    <CardContent className="flex flex-col items-center gap-4 p-6">
      <h3 className="text-lg font-semibold tracking-tight">{title}</h3>
      <p className="text-sm text-muted-foreground">{description}</p>
      {actionLabel && onAction && (
        <Button onClick={onAction}>{actionLabel}</Button>
      )}
    </CardContent>
  </Card>
);
EmptyState.displayName = 'EmptyState';

export { EmptyState };
export type { EmptyStateProps };
